import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ListStateService {
  scrollOffset = 0;
  selectedId: string | null = null;
  selectedIndex = 0;

  saveOffsetState(offset: number) {
    this.scrollOffset = offset;
  }

  saveScrolledState(state: { selectedId: string; selectedIndex: number }) {
    this.selectedId = state.selectedId;
    this.selectedIndex = state.selectedIndex;
  }

  clearState() {
    this.scrollOffset = 0;
    this.selectedId = null;
  }
}
